import styled from 'styled-components';

export const Divider = styled.hr<{ spacing?: 'sm' | 'md' | 'lg' }>`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
  margin: ${({ spacing = 'md', theme }) => theme.spacing[spacing]} 0;
`;
